import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatTable } from '@angular/material/table';
import { CustomValidators } from '../../../../../../../shared/custom-validators';
import { BaseForm } from '../../../../../../../shared/product/baseForm';
import { FormValidatorService } from '../../../../../../../shared/services/form-validator.service';
import { Validators } from '../../../../../../../shared/validators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-subscription-step-two',
  templateUrl: './subscription-step-two.component.html',
  styleUrls: ['./subscription-step-two.component.scss']
})
export class SubscriptionStepTwoComponent extends BaseForm implements OnInit, AfterViewInit {
  displayedColumns = ['PackageName', 'Duration', 'Period', 'Price', 'Actions'];
  propertiesColumns: string[] = [];
  @ViewChild(MatTable) table!: MatTable<any>;

  isUpdate: any;
  id: any;
  @Input() productObject: any;
  formValidator: FormValidatorService;
  stepForm!: FormGroup;
  productTypeId: any;
  packageArray: any[] = [];
  noPackage: boolean = true;
  breaked: boolean = false;
  hasPackage: boolean = false;
  PackageForm!: FormGroup;

  packageController = {
    "Package Name": {
      'fieldName': 'Package Name',
      'fieldNameAr': 'إسم الباقة',
      'fieldType': 'package_name',
      'isStaticUI': true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        }
      ]
    },
    "Package Price": {
      'fieldName': 'Package Price',
      'fieldNameAr': 'سعر الباقة',
      'fieldType': 'Package Price',
      'isStaticUI': true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: Validators.min(1),
          message: `${this.validationMsg.min} 1`,
          messageAr: `${this.validationMsgAr.min} 1`
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        }
      ]
    },
    "Period": {
      'fieldName': 'Period',
      'fieldNameAr': 'الفترة',
      'fieldType': 'Period',
      'isStaticUI': true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: Validators.min(1),
          message: `${this.validationMsg.min} 1`,
          messageAr: `${this.validationMsgAr.min} 1`
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        }
      ]
    },
    "Duration": {
      fieldName: "Duration",
      'fieldNameAr': 'المدة',
      fieldType: "no-label-select-list",
      fieldValues: [],
      defaultValue: "Days",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        }
      ]
    }
  }

  controllers = {
    subscriptionImg: {
      'fieldName': 'Subscription Image',
      'fieldNameAr': 'صورة الإشتراك',
      'fieldType': 'subscription_image',
      'isStaticUI': true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        }
      ]
    },
    Packages: {
      'fieldName': 'Packages',
      'fieldType': 'Packages',
      'isStaticUI': true,
      defaultValue: '',
      validators: []
    },
    is_buyer_info: {
      'fieldName': 'Do you want to Add extra Buyer info fields to your product?',
      'fieldNameAr': 'هل تريد ان تأخذ معلومات اضافية من المشتري؟',
      'fieldType': 'Do you want to Add extra Buyer info fields to your product?',
      'isStaticUI': true,
      defaultValue: '',
      validators: []
    }
  }

  constructor(private fb: FormBuilder, private translate: TranslateService) {
    super();
    this.formValidator = new FormValidatorService();
  }

  ngOnInit() {
    this.PackageForm = this.fb.group({
      Packages: this.fb.array([])
    });

    this.addPackage();
    this.initTranslations();
    this.PackageForm.valueChanges.subscribe(() => {
      this.updateStepTwoForm();
    });

    this.stepForm = this.formValidator.createForm(Object.values(this.controllers));
    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();

    this.translate.onLangChange.subscribe(() => {
      this.initTranslations();
    });
  }

  ngAfterViewInit() { }

  private initTranslations() {
    this.packageController.Duration.fieldValues = [
      { name: this.translate.instant("DURATION.DAYS") },
      { name: this.translate.instant("DURATION.WEEKS") },
      { name: this.translate.instant("DURATION.MONTHS") }
    ];
    this.propertiesColumns = [
      this.translate.instant("COLUMN.PACKAGE_NAME"),
      this.translate.instant("COLUMN.DURATION"),
      this.translate.instant("COLUMN.PERIOD"),
      this.translate.instant("COLUMN.PRICE")
    ];
  }

  updateStepTwoForm() {
    this.noPackage = false;
    this.stepForm.controls['Packages'].setValue([]);
    for (let pack of this.PackageList.controls) {
      if (pack.valid) {
        this.stepForm.controls['Packages'].setValue([...this.stepForm.controls['Packages'].value, pack.value]);
        if (this.noPackage != true) this.noPackage = false;
      } else {
        this.noPackage = true;
      }
    }
  }

  get PackageList() {
    return this.PackageForm.get('Packages') as FormArray;
  }

  removePackage(i: number) {
    this.PackageList.removeAt(i);
  }

  addPackage() {
    if (this.PackageList.valid) {
      this.PackageList.push(this.formValidator.createForm(Object.values(this.packageController)));
    }
  }

  addIncomingPackage(p: any) {
    this.addPackage();
    const lastIndex = this.PackageList.controls.length - 1;
    this.PackageList.controls[lastIndex].setValue(this.mapPackageData(p));
  }

  private mapPackageData(p: any) {
    return {
      "Package Name": p.packageName,
      "Package Price": p.price,
      "Duration": p.durationType,
      "Period": p.period
    };
  }

  setHasPackage(hasPackage: any) {
    this.hasPackage = hasPackage;
  }

  clearPackageForm() {
    this.stepForm.controls['Packages'].setValue([]);
  }

  convertControls(name: string) {
    return this.stepForm.get(name) as FormControl;
  }

  convertPackageControls(index: number, name: string) {
    return this.PackageList.controls[index].get(name) as FormControl;
  }
}
